module.exports = __webpack_public_path__ + "img/logo-c.59e74104.png";